import React, { useEffect } from 'react';
import { sendGlobalErrorProps } from 'cu-master-layout-prop-manager';

const Page404 = () => {
  useEffect(() => {
    sendGlobalErrorProps({
      errorType: 'notFoundError',
    });
  }, []);
  return <></>;
};
export { Page404 };
